import React, { useReducer, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Send, CheckCircle, AlertCircle, Building, Users, Award, Globe, FileText, CheckSquare } from 'lucide-react';
import { SectionTitle, Row, Col, FormField, Textarea } from '../../../SharedInputs';

export function SectionBenefits({ state, dispatch, errors }) {
  const updateField = (field, value) => {
    dispatch({ type: 'UPDATE_FIELD', section: 'benefits', field, value });
  };

  return (
    <div>
      <SectionTitle icon={Globe}>Benefits to CIET</SectionTitle>
      
      <Row>
        <Col span={12}>
          <FormField 
            label="What benefits can your company offer to CIET?" 
            required 
            error={errors.find(e => e.includes('Benefits description'))}
            hint="Explain how partnering with your agency will benefit CIET"
          >
            <Textarea
              value={state.benefits.benefitsDescription}
              onChange={(e) => updateField('benefitsDescription', e.target.value)}
              placeholder="Describe the value your company brings..."
              rows={6}
            />
          </FormField>
        </Col>
      </Row>
    </div>
  );
}